import { EBonusMaxBet } from '@lbs/shared-rp-types'
import { z } from 'zod'

export const rpBonusFormSchema = z.object({
  name: z.string().nonempty({ message: 'Имя обязательно' }).min(3),
  min: z.preprocess(
    (val) => Number(val),
    z.number().int().positive({ message: 'Значение min должно быть целым положительным числом' })
  ),
  maxPayout: z.preprocess(
    (val) => (val === '' ? undefined : Number(val)),
    z.number().int().positive({ message: 'Значение maxPayout должно быть целым положительным числом' }).optional()
  ),
  payouts: z.array(
    z.object({
      multiplier: z.preprocess(
        (val) => Number(val),
        z.number().positive({ message: 'Множитель должен быть положительным числом' })
      ),
      combination: z.string().nonempty({ message: 'Комбинация обязательна' }),
    })
  ),
  max: z.nativeEnum(EBonusMaxBet, {
    errorMap: () => ({ message: 'Значение max должно быть одним из: NO_LIMIT, ANTE' }),
  }),
})

export type TRpBonusFormData = z.infer<typeof rpBonusFormSchema>
